module.exports = __webpack_public_path__ + "img/hzhs1.6958779b.jpg";